import { useQuery } from "react-query";
import { Button, Space } from "antd";

import { useStore } from "../../config/store";
import { IClean } from "../../config/types";
import { API } from "../../api";
import { MyMarkdown } from "../MyMarkdown";

export const HowinBlock = () => {
  const { clean, cancelDrawer } = useStore();
  const { id } = clean as IClean;
  const { data } = useQuery("howin", () => API.getHowin(id));
  
  if (!data) return null;
  
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <MyMarkdown text={data.text} />
      <Button onClick={cancelDrawer} block size="large">
        Закрыть
      </Button>
    </Space>
  );
};
